export * from './constants';
export { LoraDetailWindow } from './components/lora/Detail';

import { ModelWindows } from './components';

export default {
  type: 'models',

  setup: async ({ app }) => {
    app.extension.registerComponent('root', { Component: ModelWindows });
  },
};
